import { memo } from "react";

import FormFieldRenderer from "./FormFieldRenderer";
import { StyledRow } from "./styles";
import type { Row } from "./types";

interface RowRendererProps {
  row: Row;
}

function RowRenderer({ row }: Readonly<RowRendererProps>) {
  return (
    <StyledRow>
      {row.fields
        .filter((field) => field.mustBeDisplayed())
        .map((field) => (
          <FormFieldRenderer
            key={field.id()}
            fieldId={field.id()}
            summary={false}
          />
        ))}
    </StyledRow>
  );
}

export default memo(RowRenderer);
